<template>
  <load-area v-if="hotels == null"></load-area>
  <div class="row" v-if="hotels != null">
    <div class="col">
      <div class="card">
        <div class="card-body p-0">
          <cardHead
            :title="'Temp Reservations'"
            :key="isSelectCount"
            :buttons="[
              {
                title: (isSelectCount > 0 ? '(' + isSelectCount + ') ' : '') + 'Send to Reset Queue',
                icon: 'mdi mdi-layers-off',
                emit: 'sendToQueue',
                class:
                  'btn-primary ' +
                  (isSelectCount > 0 ? '' : 'none'),
              },
            ]"
            @sendToQueue="sendToQueue"
          ></cardHead>
          <Form
            method="dialog"
            v-slot="{ errors }"
            class="floating-labels row  p-20 p-b-10"
            ref="form"
          >
            <div class="col">
              <searchSelect
                :title="'SoftwareId'"
                v-model="model.SoftwareId"
                :errors="errors"
                @change="data=null; isSelectCount=0"
                :data="
                  $orderByArray(
                    softwares.map((x) => {
                      return {
                        value: x.Id,
                        text: x.Name,
                      };
                    }),
                    'Name',
                    false,
                    false
                  )
                "
              >
              </searchSelect>
            </div>
            <div class="col">
              <searchSelect
                :title="'CustomerId'"
                v-model="model.CustomerId"
                :errors="errors"
                :data="
                  $orderByArray(
                    customers.map((x) => {
                      return {
                        value: x.Id,
                        text: x.Name,
                      };
                    }),
                    'Name',
                    false,
                    false
                  )
                "
              >
              </searchSelect>
            </div>
            <div class="col">
              <searchSelect
                :title="'HotelId'"
                v-model="model.HotelId"
                :errors="errors"
                :data="
                  $orderByArray(
                    hotels.map((x) => {
                      return {
                        value: x.Id,
                        text: x.Name,
                      };
                    }),
                    'Name',
                    false,
                    false
                  )
                "
              >
              </searchSelect>
            </div>
            <div class="col-auto">
              <Btn
                class="btn-success"
                @click="get()"
                :disabled="reportProcess"
                :process="reportProcess"
                >Get</Btn
              >
            </div>
          </Form>
          <elektraWeb
            v-if="model.SoftwareId==6 && data!=null"
            ref="elektraWebTempRezRef"
            :data="data"
            @selectionChanged="isSelectCount = $event"
          ></elektraWeb>
          <fidelio v-if="model.SoftwareId==13 && data!=null" :data="data"
          ref="fidelioTempRezRef"
          @selectionChanged="isSelectCount = $event"
          ></fidelio>
          <load-area v-if="reportProcess" class="border-top"></load-area>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import elektraWeb from "./elektraweb.vue";
import fidelio from "./fidelio.vue";
export default {
  name: "tempReservations",
  components:{
    elektraWeb,
    fidelio
  },
  data() {
    return {
      softwares: [],
      customers: [],
      hotels: [],
      data: null,
      showShow: null,
      model: {
        SoftwareId: null,
        HotelId: null,
        CustomerId: null,
      },
      reportProcess: false,
      isSelectCount: 0,
    };
  },
  created() {
    this.$appAxiosAdmin.get(`CustomerHotels`).then((response) => {
      this.hotels = this.$orderByArray(response.data, "Name", false, false);
    });
    this.$appAxiosAdmin.get(`Customers`).then((response) => {
      this.customers = this.$orderByArray(response.data, "Name", false, false);
    });
    this.$appAxiosAdmin.get(`Softwares`).then((response) => {
      this.softwares = response.data.filter((x) => x.Id == 13 || x.Id == 6);
      this.model.SoftwareId = this.softwares[1].Id;
    });
    // this.getReport();
    // this.get();
  },
  watch: {
    // showShow(){
    //   window.open(
    //     "https://reservations.ams3.digitaloceanspaces.com/logs/"+this.showShow,
    //     '_blank' // <- This is what makes it open in a new window.
    //   );
    // }
  },
  methods: {
    get() {
      this.data = null;
      this.isSelectCount = 0;
      this.reportProcess = true;
      let url = "pms/" + this.model.SoftwareId + "/TempReservations";
      if (this.model.SoftwareId == 6) {
        url = "TempReservations";
      }
      this.$appAxiosAdmin
        .post(url, this.model)
        .then((response) => {
          this.data = this.$orderByArray(
            response.data,
            "Date",
            true,
            false,
            true
          ).map((x) => {
            return { ...x, isSelected: false };
          });
          this.reportProcess = false;
        })
        .catch((err) => {
          this.$swal({
            icon: "error",
            title: "Error",
            text: err,
          });
          this.data = [];
          this.reportProcess = false;
        });
    },
    sendToQueue() {
      const rows = this.data.filter((x) => x.isSelected);
      if (!rows.length) return;
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to send the selected items to the reset queue?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (!question.isConfirmed) return;
        const body = rows.map((r) => ({
          HotelId: r.HotelId,
          TempReservationId: r.Id,
        }));
        this.$appAxiosAdmin
          .post("TempReservations/QueueReset", body)
          .then((response) => {
            const { queued = [], skipped = [], failed = [] } = response.data;
            if(this.$refs.elektraWebTempRezRef) this.$refs.elektraWebTempRezRef.resetSelection();
            if(this.$refs.fidelioTempRezRef) this.$refs.fidelioTempRezRef.resetSelection();
            
            this.$swal({
              icon: failed.length ? "warning" : "success",
              title: "Reset Queue",
              html: [
                "📤 Sent: " + rows.length,
                queued.length
                  ? '<span style="color:#28a745">✓</span> Queued: ' + queued.length
                  : null,
                skipped.length
                  ? '<span style="color:#ffc107">⏭</span> Skipped: ' + skipped.length
                  : null,
                failed.length
                  ? '<span style="color:#dc3545">✗</span> Failed: ' + failed.length
                  : null,
              ]
                .filter(Boolean)
                .join("<br>"),
              confirmButtonText: "Okey",
            });
          })
          .catch((err) => {
            this.$isError(err);
          });
      });
    },
    reload() {
      this.get();
    },
    truncate() {
      this.$swal({
        icon: "question",
        title: "Warning",
        text: "Are you sure you want to truncate Asyasoft logs?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .get(`KOLAYREZ/PMSLogs/Truncate`)
            .then(() => {
              this.reload();
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The successfully truncated.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.report li {
  border-left: none !important;
  border-right: none !important;
}
.report li:first-child {
  border-top: none !important;
}
.treeViewInput > div > ul {
  height: unset;
}
</style>
